(function () {
  if (customElements.get('preview-ready-notice')) return;
  var audioEvents = ['loadedmetadata', 'loadeddata', 'durationchange', 'progress', 'canplaythrough', 'emptied', 'abort'];

  class PreviewReadyNotice extends HTMLElement {
    connectedCallback() {
      this.handled = false;
      this.target = null;
      this.audio = null;
      this.onReady = this.tryShow.bind(this);
      this.onAudioError = () => {
        console.error('[preview-ready-notice] Preview audio failed to load:', this.audio.error);
        this.tryShow();
      };
      this.onClick = this.handleClick.bind(this);
      this.onScroll = this.handleScroll.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('preview:sections-reveal', this.onReady);
      document.addEventListener('preview:sales-visible', this.onReady);
      document.addEventListener('preview:loaded', this.onReady);
      this.tryShow();
    }

    disconnectedCallback() {
      this.dismiss();
      this.watchAudio(null);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('preview:sections-reveal', this.onReady);
      document.removeEventListener('preview:sales-visible', this.onReady);
      document.removeEventListener('preview:loaded', this.onReady);
      clearTimeout(this.highlightTimer);
      if (this.target) this.target.classList.remove('prn-target-highlight');
    }

    tryShow() {
      if (this.handled) return;
      this.target = document.querySelector('[data-preview-section].preview-visible .bps-player');
      if (!this.target) return;
      this.watchAudio(this.target.closest('[data-preview-section]').querySelector('audio'));
      if (!this.isFullyBuffered()) {
        this.hidden = true;
        window.removeEventListener('scroll', this.onScroll);
        return;
      }
      if (!this.hidden) return;

      this.hidden = false;
      this.startScrollY = window.scrollY;
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    watchAudio(audio) {
      if (this.audio !== audio) {
        if (this.audio) {
          audioEvents.forEach((name) => this.audio.removeEventListener(name, this.onReady));
          this.audio.removeEventListener('error', this.onAudioError);
        }
        this.audio = audio;
        if (audio) {
          audioEvents.forEach((name) => audio.addEventListener(name, this.onReady));
          audio.addEventListener('error', this.onAudioError);
        }
      }
      if (audio && audio.preload !== 'auto') {
        audio.preload = 'auto';
        if (audio.getAttribute('src')) audio.load();
      }
    }

    isFullyBuffered() {
      var audio = this.audio;
      if (!audio || !audio.currentSrc || audio.error || audio.readyState < 2 ||
          !Number.isFinite(audio.duration) || audio.duration <= 0) return false;
      var buffered = audio.buffered;
      // Allow 50 ms for media timestamp rounding, but never gaps in the audio.
      return buffered.length === 1 && buffered.start(0) <= 0.05 &&
        buffered.end(0) >= audio.duration - 0.05;
    }

    handleScroll() {
      if (window.scrollY - this.startScrollY < 40) return;
      var rect = this.target.getBoundingClientRect();
      var visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      if (visibleHeight >= rect.height / 2) this.dismiss();
    }

    handleClick(event) {
      if (event.target.closest('[data-prn-listen]')) {
        event.stopPropagation();
        this.goToPreview();
      }
    }

    dismiss() {
      this.handled = true;
      this.hidden = true;
      window.removeEventListener('scroll', this.onScroll);
    }

    goToPreview() {
      this.dismiss();
      var playButton = this.target.querySelector('.bps-play-button');
      this.target.classList.add('prn-target-highlight');
      if (playButton) playButton.focus({ preventScroll: true });
      var rect = this.target.getBoundingClientRect();
      var top = window.scrollY + rect.top - Math.max(100, (window.innerHeight - rect.height) / 2);
      window.scrollTo({
        top: Math.max(0, top),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.highlightTimer = setTimeout(() => {
        this.target.classList.remove('prn-target-highlight');
      }, 3500);
    }
  }

  customElements.define('preview-ready-notice', PreviewReadyNotice);
})();
